import React, { forwardRef } from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { ControllableOptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { useFormContext } from 'react-hook-form';

import st from '../popovers.module.sass';

function BackpackFilterPopover(
  {
    name = 'backpack_states',
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { control } = useFormContext();

  return (
    <FilterPopover
      {...props}
      name="backpack_states"
      ref={ref}
    >
      <ControllableOptionsFilter
        control={control}
        isSearchable={false}
        name={name}
        options={EVENT_ENUMS.ACCESSORIES.BACKPACK.raw}
      />
      <div className={st.Divider} />
    </FilterPopover>
  );
}

const BackpackFilterPopoverWithRef = forwardRef(BackpackFilterPopover);
export { BackpackFilterPopoverWithRef as BackpackFilterPopover };
